import { render } from "./RankingTableSummary006.vue?vue&type=template&id=2b48c038&scoped=true"
import script from "./RankingTableSummary006.vue?vue&type=script&lang=js"
export * from "./RankingTableSummary006.vue?vue&type=script&lang=js"

import "./RankingTableSummary006.vue?vue&type=style&index=0&id=2b48c038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b48c038"]])

export default __exports__